function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M23 0C10.31 0 0 10.31 0 23s10.31 23 23 23 23-10.31 23-23S35.69 0 23 0zm0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21S2 34.61 2 23 11.39 2 23 2zm0 7a3 3 0 100 6 3 3 0 000-6zm-4 10v2h2v13h-2v2h8v-2h-2V19h-6z",
  fill: "#FFF"
});

var SvgInfo = function SvgInfo(props) {
  return React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iNDYiIHZpZXdCb3g9IjAgMCA0NiA0NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjMgMEMxMC4zMSAwIDAgMTAuMzEgMCAyM3MxMC4zMSAyMyAyMyAyMyAyMy0xMC4zMSAyMy0yM1MzNS42OSAwIDIzIDB6bTAgMmMxMS42MSAwIDIxIDkuMzkgMjEgMjFzLTkuMzkgMjEtMjEgMjFTMiAzNC42MSAyIDIzIDExLjM5IDIgMjMgMnptMCA3YTMgMyAwIDEwMCA2IDMgMyAwIDAwMC02em0tNCAxMHYyaDJ2MTNoLTJ2Mmg4di0yaC0yVjE5aC02eiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+";
export { SvgInfo as ReactComponent };